export const loginStudent = (session) => {
  return {
    type: "LOGIN_STUDENT",
    payload: session,
  };
};
export const logoutStudent = () => {
  return {
    type: "LOGOUT_STUDENT",
  };
};
